export default {
  profile: '個人情報',
  logout: 'ログアウト',
  admin: '管理者',
  accontCenter: 'アカウントセンター',
};
